import { render, staticRenderFns } from "./MortgageSurvey.vue?vue&type=template&id=34698004"
import script from "./MortgageSurvey.vue?vue&type=script&lang=js"
export * from "./MortgageSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports